import React from 'react';
import { connect } from 'react-redux';
import { fetchContacts } from 'src/services/cases.service';
import ContactsPres from '../Presentation/ContactsPres';

class ContactsContainer extends React.Component {
  state = {
    contactResponse: null,
  };
  componentDidMount() {
    if (this.props.caseId) {
      this.setState({ contactResponse: null });
      fetchContacts({ CaseId: this.props.caseId, pageNumber: 1, pageSize: 1000 }).then(response => {
        this.setState({ contactResponse: response });
      });
    }
  }
  componentWillUnmount() {}
  render() {
    return <ContactsPres caseId={this.props.caseId} contacts={this.state.contactResponse} history={this.props.history} />;
  }
}
const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(ContactsContainer);
